export default __webpack_public_path__ + "static/media/384-384-min.d0489ec5.png";